import { useTypedParams } from '@sorare/routing';

import { Position } from '@sorare/core/src/__generated__/globalTypes';

import { RequestLineupForm } from '@sorare/gameplay/src/components/noCardRoute/RequestLineupForm';
import { disclaimerMessages } from '@sorare/gameplay/src/lib/noCardRoute';

import { PageParams } from './__generated__/routeParams';

const slotRounds = [[0], [1, 2, 3], [4]];
const lineups = [
  {
    positions: [Position.Goalkeeper],
    label: 'Goalkeeper',
  },
  {
    positions: [Position.Defender],
    label: 'Defender',
  },
  {
    positions: [Position.Midfielder],
    label: 'Midfielder',
  },
  {
    positions: [Position.Forward],
    label: 'Forward',
  },
  {
    positions: [Position.Defender, Position.Midfielder, Position.Forward],
    label: 'Extra',
  },
];

const NoCardEntry = () => {
  const { so5FixtureId } = useTypedParams<PageParams>();

  return (
    <RequestLineupForm
      so5FixtureId={so5FixtureId}
      slotRounds={slotRounds}
      lineup={lineups}
      disclaimers={[
        disclaimerMessages.eligibilityCheck,
        disclaimerMessages.leaderboardSelection,
        disclaimerMessages.captain,
      ]}
    />
  );
};

export default NoCardEntry;
